import { render, staticRenderFns } from "./cloudApplication.vue?vue&type=template&id=b05c57c8&scoped=true&"
import script from "./cloudApplication.vue?vue&type=script&lang=js&"
export * from "./cloudApplication.vue?vue&type=script&lang=js&"
import style0 from "./cloudApplication.vue?vue&type=style&index=0&id=b05c57c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05c57c8",
  null
  
)

export default component.exports